import { RecordManualJobCostMutation, ReverseManualJobCostMutation } from "~/gql/mutations/produce/jobCost.generated";
import {
	GetJobCostBreakdownQuery,
	GetJobCostRecordsQuery,
	GetJobCostSubcategoriesQuery,
	GetJobCostSummaryQuery,
	GetJobCostTimelineQuery,
	GetLotCostBreakdownQuery,
	GetLotCostRecordsQuery,
	GetLotCostSummaryQuery,
	GetLotCostTimelineQuery
} from "~/gql/queries/produce/jobCost.generated";

export const jobCostEndpoints = {
	GetJobCostBreakdown: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetJobCostBreakdownQuery) => res
	},
	GetJobCostRecords: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetJobCostRecordsQuery) => res
	},
	GetJobCostSubcategories: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetJobCostSubcategoriesQuery) => res
	},
	GetJobCostSummary: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetJobCostSummaryQuery) => res
	},
	GetJobCostTimeline: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetJobCostTimelineQuery) => res
	},
	GetLotCostBreakdown: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetLotCostBreakdownQuery) => res
	},
	GetLotCostRecords: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetLotCostRecordsQuery) => res
	},
	GetLotCostSummary: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetLotCostSummaryQuery) => res
	},
	GetLotCostTimeline: {
		providesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: GetLotCostTimelineQuery) => res
	},
	RecordManualJobCost: {
		invalidatesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: RecordManualJobCostMutation) => res
	},
	ReverseManualJobCost: {
		invalidatesTags: ["JobCosts"] as AddTagTypes,
		transformResponse: (res: ReverseManualJobCostMutation) => res
	}
};
